<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Dragable & Swipe View</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <draggable v-model="menuArr" :options="dragOptions" @start="drag=true" @change="onChange">
                            <div v-for="(element, index) in menuArr" :id="'menu-'+element.id" :key="'menu-'+element.id" class="edit-menu">
                                <img class="drag-handle" src="/static/images/app-bar-icon.png">
                                <p>{{ element.menu_title }}</p>
                                <div class="menu-actions">
                                    <a href="javascript:void(0)" id="edit-menu" v-on:click="toggleEditMenu('menu-'+element.id, index)"><img src="/static/images/edit-icon.png"></a>
                                    <a href="javascript:void(0)" id="delete-menu" v-on:click="deleteMenu(element.id)"><img src="/static/images/delete-icon.png"></a>
                                </div>
                            </div>
                        </draggable>
                    </div>
                </div>
                <p> Menu Sequence in Back-end</p>
                {{menuArr}}
                <!-- Forms -->
            </div>
            <!--page content-->
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <template>
                            <swiper class="sales-programs-menu" :options="swiperOptionSubMenu" ref="mySwiper">
                                <!-- <slick class="sales-programs-menu" ref="slickMenu" :options="slickOptionsMenu"> -->
                                <template v-for="(menuLoop, index1) in menuArr">
                                    <swiper-slide v-bind:key="'slide_'+index1">
                                        <span :class="'spm-menu ' + menuLoop.icon_url"></span>
                                        <span>Element : {{index1 +1 }} : {{menuLoop.menu_title}}</span>
                                    </swiper-slide>
                                </template>
                                <!--<div class="swiper-pagination" slot="pagination"></div>-->
                                <!-- </slick> -->
                            </swiper>
                        </template>
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--<div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin vertical">
                        <swiper :options="swiperOption" ref="menuSwiper">
                            <swiper-slide class="text">
                                <div class="content">
                                    <h4 class="title">Demo Text</h4>
                                    <p>This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text.</p>
                                    <p>This is a demo text. This is a demo text. </p>
                                    <p>This is a demo text. This is a demo text. This is a demo text. 
                                        <blockquote> This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. 
                                            This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. 
                                            This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. 
                                        </blockquote>
                                    </p>
                                    <p>This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text.</p>
                                    <br>
                                    <p>This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text.</p>
                                    <br>
                                    <p>This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. This is a demo text. </p>
                                </div>
                            </swiper-slide>
                            <div class="swiper-scrollbar" slot="scrollbar"></div>
                        </swiper>
                    </div>
                </div>
            </div>-->
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import BackendFooter from '@/components/backend/partials/footer';

    import draggable from 'vuedraggable';
    Vue.use(draggable);

    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
            draggable,
            swiper,
            swiperSlide,
        },
        data() {
            return {
                 swiperOption: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    freeMode: true,
                    scrollbar: {
                        el: '.swiper-scrollbar'
                    },
                    on: {
                        /*init: function () {
                            console.log("init");
                            //setTimeout(function(){
                                let windowhight = $(window).height();
                                let appsidenev = $(".app-sidebar-nav").outerHeight();
                                //alert("Window : "+windowhight +"\n"+"Header : "+appsidenev + "\n"+ "Sub : "+(windowhight-appsidenev));
                                $(".vertical .swiper-container").height(windowhight-appsidenev);
                                // $(".vertical .swiper-container").height(500)
                            //}, 100);
                        },
                        click() {
                            console.log("clicked");
                            //setTimeout(function(){
                                let windowhight = $(window).height();
                                let appsidenev = $(".app-sidebar-nav").outerHeight();
                                //alert("Window : "+windowhight +"\n"+"Header : "+appsidenev + "\n"+ "Sub : "+(windowhight-appsidenev));
                                $(".vertical .swiper-container").height(windowhight-appsidenev);
                                // $(".vertical .swiper-container").height(500)
                            //}, 100);
                        },
                        resize() {
                            console.log("resize");
                            //setTimeout(function(){
                                let windowhight = $(window).height();
                                let appsidenev = $(".app-sidebar-nav").outerHeight();
                                //alert("Window : "+windowhight +"\n"+"Header : "+appsidenev + "\n"+ "Sub : "+(windowhight-appsidenev));
                                $(".vertical .swiper-container").height(windowhight-appsidenev);
                                // $(".vertical .swiper-container").height(500)
                            //}, 100);
                        },*/
                    },
                    mousewheel: true
                },
                swiperOptionSubMenu: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1700: {
                            slidesPerView: 4.2
                        },
                        1600: {
                            slidesPerView: 3.9
                        },
                        1500: {
                            slidesPerView: 3.6
                        },
                        1400: {
                            slidesPerView: 3.4
                        },
                        1300: {
                            slidesPerView: 3.2
                        },
                        1200: {
                            slidesPerView: 2.8
                        },
                        1000: {
                            slidesPerView: 2.2
                        },
                        667: {
                            slidesPerView: 2.2
                        },
                        480: {
                            slidesPerView: 1.5
                        },
                        360: {
                            slidesPerView: 1.3
                        }
                    }
                },
                menuArr: [
                    {
                        "id": 1,
                        "menu_title": "Bulletin Board",
                        "icon_url": "icon-Bulletin-Board",
                    },
                    {
                        "id": 2,
                        "menu_title": "Inventory",
                        "icon_url": "icon-Inventory",
                    },
                    {
                        "id": 3,
                        "menu_title": "Favorites",
                        "icon_url": "icon-Favorites",
                    },
                    {
                        "id": 4,
                        "menu_title": "Save The Date",
                        "icon_url": "icon-Save-the-Date",
                    },
                    {
                        "id": 5,
                        "menu_title": "Sales Programs",
                        "icon_url": "icon-Sales-Programs",
                    }

                ]
            }



        },
        beforeMount: function () {

        },
        mounted: function () {
            var self = this;
            self.$refs.mySwiper.swiper.slideTo(Math.round(self.menuArr.length / 2), 0);
            /*self. $nextTick(function () {
                let windowhight = $(window).height();
                let appsidenev = $(".app-sidebar-nav").outerHeight();
                $(".vertical .swiper-container").height(windowhight-appsidenev);
            });*/
        },
        methods: {
            onChange: function (event) {
                var self = this;
            },
            resizeSidebar: function(){
                let self=this;
                self.$refs.menuSwiper.resize();
            },
        },
        computed: {
            dragOptions() {
                return {
                    group: 'menu',
                    handle: ".drag-handle",
                }
            },

        },
    }
</script>
<style>
.vertical .swiper-container{
    height: 300px;
}
.swiper-slide.text {
	font-size: 18px !important;
	text-align: left !important;
	height: auto;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	padding: 30px;
}

.swiper-slide.text > .content > .title {
	margin: 0;
	text-align: center;
	margin-bottom: .75em;
}

.swiper-slide.text > .content > p,
  .swiper-slide.text > .content blockquote {
	line-height: 2;
	text-indent: 2em;
}

.swiper-slide.text > .content blockquote {
	background-color: #ddd;
	margin-left: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dragable.vue